export const style = {
  downArrowIcon: {
    alignSelf: 'center',
    height: '14px',
    width: '14px'
  },
  locationIcon: {
    alignSelf: 'flex-start',
    height: '30px',
    width: '30px',
    marginRight: '6px'
  },
  pincodeContainer: {
    padding: '14px 16px', width: '100%',
    backgroundColor: '#FFFFFF',
    borderRadius: '10px',
    zIndex: 1000,
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between'
  },
  aboutText: {
    fontSize: '14px',
    fontFamily: 'JioType-Medium',
    color: '#000000',
    alignSelf: 'center'
  }
}